// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"1":"23626121","77":"ec84acb1","730":"8967d46d","784":"4361a648","951":"27ec2ce1"}[chunkId] + ".css";
};